// React
import React from "react"
import { graphql, useStaticQuery } from "gatsby"

// Components
import Seo from "../components/Seo"
import MasonryGrid from "../components/MasonryGrid"
import HeaderBlock from "../components/HeaderBlock"
import BackgroundWrapper from "../components/BackgroundWrapper"

// Utils
import formatContentFulEntries from "../utils/formatContentfulEntries"
import getJournalGridItems from "../utils/getJournalGridItems"

// Material ui
import { Box } from "@mui/material"
// import * as routes from "../constants/routes"

function useJournals() {
  return useStaticQuery(
    graphql`
      query {
        homeData: allContentfulHomePage {
          edges {
            node {
              journalDescription
              journalTitle
            }
          }
        }
        journalsData: allContentfulJournal(
          filter: {
            sys: { revision: { ne: null } }
            featuredImage: { file: { fileName: { ne: null } } }
          }
          sort: { fields: comingSoon }
        ) {
          edges {
            node {
              id
              title
              slug
              titleColor
              comingSoon
              featuredImage {
                gatsbyImageData(
                  width: 600
                  placeholder: TRACED_SVG
                  formats: [AUTO, WEBP]
                )
              }
              thumbnailImage {
                gatsbyImageData(
                  width: 600
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
              body {
                raw
              }
            }
          }
        }
      }
    `
  )
}

export default function JournalsPage() {
  const { journalsData, homeData } = useJournals()
  const journalGridItems = getJournalGridItems(journalsData)

  const homeDataFormatted = formatContentFulEntries(homeData)[0]
  const { journalDescription, journalTitle } = homeDataFormatted

  return (
    <BackgroundWrapper
      backgroundColor="background.light"
      bottomGutterSpacing={8}
    >
      <Seo
        title="Journal"
        description="Everyone has the freedom to follow their own path."
        pathname="/journal"
        article={null}
      />
      <HeaderBlock
        title={journalTitle ? journalTitle : "Journal Fallback"}
        titleComponent="h1"
        description={journalDescription ? journalDescription : null}
        bottomGutterSpacing={6}
        topGutterSpacing={6}
        backgroundColor="light"
      />
      <MasonryGrid items={journalGridItems} />
      {/* Potential solution for 2000 pixel limit for masonry: Split journal array in N parts, every 6-8 images or so and create a new Masonry Grid for it */}
    </BackgroundWrapper>
  )
}
